__turbopack_context__.v({
  "className": "WBuuxG_className",
  "variable": "WBuuxG_variable",
});
